import axios from "axios";
import { StatisticsURL } from "../Services";
import { authenticatedHeader } from "../DefaultConfig";
import { HideAwaiting, ShowAwaiting } from "../../util/Awaiting";
import { authenticatedGetAPI } from "../GenericAPICall";

type ContentFlexFilterDTO = {
  author?: string;
  source?: string;
  keyword?: string;
  adjacentKeyword?: string;
  adjective?: string;
  days?: number;
};

export async function findContentDetail(id: number) {
  ShowAwaiting();
  var res = await axios.get(
    StatisticsURL + "api/statistics/article/whatsnew/detail/" + id,
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function whatsnew() {
  var res = await authenticatedGetAPI(
    StatisticsURL + "api/statistics/article/whatsnew"
  );
  return res;
}

export async function findContentFlexFilter(dto: ContentFlexFilterDTO) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/content/view/flex-filter",
    {
      author: dto.author ? dto.author : "",
      source: dto.source ? dto.source : "",
      keyword: dto.keyword ? dto.keyword : "",
      adjacentKeyword: dto.adjacentKeyword ? dto.adjacentKeyword : "",
      adjective: dto.adjective ? dto.adjective : "",
      days: dto.days ? dto.days : 1,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}
